import Vue from "vue";
import Vuex from "vuex";
import * as fb from "../firebase";
import router from "../router/index";
import FlashMessage from "@smartweb/vue-flash-message";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(Vuex);
Vue.use(FlashMessage, {
  blockClass: "",
  contentClass: "",
  wrapperClass: ""
});

const store = new Vuex.Store({
  state: {
    userProfile: {
      is_authenticated() {
        return false;
      },
      has_role(role) {
        console.log(role);
        return false;
      }
    },
    cardListener: null,
    listening: false,
    cards: []
  },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setPerformingRequest(state, val) {
      state.performingRequest = val;
    },
    setCardListener(state, val) {
      if (state.cardListener) {
        console.log("Unsubbing from cards");
        state.cardListener();
      }
      state.cardListener = val;
    },
    setCards(state, val) {
      state.cards = val;
    },
    setListening(state, val) {
      state.listening = val;
    }
  },
  getters: {
    user: state => state.userProfile,
    sentCards: state => {
      return state.cards.filter(card => card.sender == fb.auth.currentUser.uid);
    },
    recCards: state => {
      return state.cards.filter(
        card => card.receiver == fb.auth.currentUser.uid
      );
    }
  },
  actions: {
    async checkListener({ dispatch }) {
      console.log("checking listener");
      if (!this.state.listening) {
        setTimeout(() => {
          dispatch("listenForCards");
        }, 1000);
      }
    },
    // eslint-disable-next-line no-unused-vars
    async saveSent({ dispatch }, data) {
      console.log("saveSent()", data.id, data.date);
      await fb.cardsCollection.doc(data.id).update({
        sent: new Date(data.date),
        stage: 2
      });
    },
    // eslint-disable-next-line no-unused-vars
    async saveRec({ dispatch }, data) {
      console.log("saveRec()", data.id, data.date);
      await fb.cardsCollection.doc(data.id).update({
        received: new Date(data.date),
        stage: 3
      });
    },
    async listenForCards() {
      const self = this;
      if (fb.auth.currentUser && !this.state.cardListener) {
        let listener = await fb.cardsCollection
          .where("received", "==", false)
          .where("users", "array-contains", fb.auth.currentUser.uid)
          .orderBy("stage")
          .orderBy("requested")
          .onSnapshot(
            snapshot => {
              let cards = [];
              snapshot.forEach(doc => {
                let card = doc.data();
                Vue.set(card, "id", doc.id);
                console.log(doc.id);
                cards.push(card);
                console.log("card", card);
              });
              self.commit("setCards", cards);
              self.commit("setListening", true);
            },
            function(error) {
              console.log(error);
              self.commit("setCardListener", null);
              self.commit("setListening", false);
            }
          );
        console.log("listener", listener);
        if (listener) {
          //this does nothing since it's always true
          console.log("listening to cards");
          this.commit("setCardListener", listener);
        }
      }
    },
    async login({ dispatch }, form) {
      // sign user in
      const { user } = await fb.auth.signInWithEmailAndPassword(
        form.email,
        form.password
      );

      // fetch user profile and set in state
      dispatch("fetchUserProfile", user);
    },
    async signup({ dispatch }, form) {
      // sign user up
      const { user } = await fb.auth.createUserWithEmailAndPassword(
        form.email,
        form.password
      );
      if (user) {
        let success = false;
        await fb.keysCollection
          .doc(form.beta)
          .update({
            taken: user.uid
          })
          .then(() => {
            success = true;
          });
        if (success) {
          // create user object in userCollections
          await fb.usersCollection
            .doc(user.uid)
            .set({
              name: form.name,
              email: form.email
            })
            .then(() => {
              fb.auth.currentUser.sendEmailVerification();
            });

          // fetch user profile and set in state
          dispatch("fetchUserProfile", user);
        }
      }
    },
    async fetchUserProfile({ commit }, user) {
      let _user;
      // fetch user profile
      await fb.usersCollection
        .doc(user.uid)
        .get()
        .then(function(doc) {
          _user = doc.data();
          _user.id = doc.id;
        })
        .catch(function(err) {
          console.log(err);
          commit("setUserProfile", { isAuthenticated: false });
          router.push("/login");
        });
      if (_user) {
        console.log(user);
        if (_user.verified_email != user.emailVerified) {
          if (user.emailVerified !== undefined) {
            console.log(
              "updating verified email",
              _user.verified_email,
              user.emailVerified
            );
            await fb.usersCollection.doc(user.uid).update({
              verified_email: user.emailVerified
            });
          }
        }
        await fb.auth.currentUser
          .getIdTokenResult(true)
          .then(idTokenResult => {
            // Confirm the user is an Admin.
            //console.log("claims", idTokenResult.claims); //TODO delete after dev
            user.claims = idTokenResult.claims;
            // set user profile in state
            user.isAuthenticated = true;
            user.details = _user;
            user.is_authenticated = function() {
              return this.isAuthenticated;
            };
            user.has_role = function(role) {
              if (this.is_authenticated && user.claims) {
                const isAdmin = "admin" in user.claims;
                return isAdmin || role in user.claims;
              }
              return false;
            };
            console.log("fetchUserProfile()", user);
            commit("setUserProfile", user);
            // change route to dashboard
            if (router.currentRoute.path === "/login") {
              router.push("/dashboard");
            } else if (router.currentRoute.path == "/register") {
              router.push("/login");
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async logout({ commit }) {
      // log user out
      await fb.auth.signOut();

      // clear user data from state
      commit("setUserProfile", { isAuthenticated: false });

      // redirect to login view
      router.push("/login");
    },
    async updateProfile({ dispatch }, user) {
      const userId = fb.auth.currentUser.uid;
      // update user object
      //const userRef =
      console.log("updated user", user);
      await fb.usersCollection.doc(userId).update({
        name: user.name,
        address: user.address,
        languages: user.languages
      });
      //console.log(userRef); //TODO use some other way?

      dispatch("fetchUserProfile", { uid: userId });
    }
  }
});

export default store;
